import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from '../Shared/Services/shared.service';
import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class ItemsService {

  readonly APIurl = environment.apiUrl;
  constructor(private http: HttpClient, private shared: SharedService) { }

  GetAllItemsByUserLogin() {
    return this.http.get(`${this.APIurl}/Product/GetAllUserItems`, this.shared.options);
  }

  GetAllItems() {
    return this.http.get(`${this.APIurl}/Product/GetAllItems`, this.shared.options);
  }


  DeleteItem(ItemId: any) {
    return this.http.get(`${this.APIurl}/Product/DeleteItem?Ids=${ItemId}`, this.shared.options);
  }

  GetAllCategoryForDrop() {
    return this.http.get(`${this.APIurl}/Category/GetAllCategoryForDrop`, this.shared.options);
  }

  GetAllColors() {
    return this.http.get(`${this.APIurl}/Colors/GetAllColors`, this.shared.options);
  }

  GetTypeOfProduct() {
    return this.http.get(`${this.APIurl}/Product/GetTypeOfProduct`, this.shared.options);
  }

  AddNewItem(item: any) {
    return this.http.post(`${this.APIurl}/Product/AddNewItem`, item, this.shared.options);
  }

  EditItem(item: any) {
    return this.http.post(`${this.APIurl}/Product/EditItem`, item, this.shared.options);
  }

  GetItemData(itemId: any) {
    return this.http.get(`${this.APIurl}/Product/GetItemData?id=${itemId}`, this.shared.options);
  }
}
